query UserDefaultDropdownData {
  companyBusinessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyDepartments(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
      name
    }
  }
  companyCorporatePeriods(
    orderBy: FISCAL_PERIOD_ASC
    filter: {
      isPeriodOpen: { equalTo: true }
      isEntryAllowed: { equalTo: true }
    }
  ) {
    nodes {
      id
      _periodYear
      fiscalPeriod
      startDate
      endDate
    }
  }
  companyUsers(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  projects(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  delegateApproverList(orderBy: USER_BY_TENANT_USER_ID__NAME_ASC) {
    nodes {
      id
      user {
        name
      }
    }
  }
}
